import axiosClient from './axiosClient';

export const getBanks = () => axiosClient.get('/api/banks');

export const createBank = (payload) => axiosClient.post('/api/banks', payload);

export const updateBank = (id, payload) => axiosClient.put(`/api/banks/${id}`, payload);

export const deleteBank = (id) => axiosClient.delete(`/api/banks/${id}`);
